module.exports = __webpack_public_path__ + "img/政策与制度_01.a7afd4a1.jpg";